<template lang="pug">
  m-table(
    store-name="documentlogs"
    :headers="headers"
    :query-filter="queryFilter"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockDocumentLogs',
  components: { MTable },
  props: {
    documentId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'User',
          valueFormatter: log => this._.get(log, 'user.name') || this._.get(log, 'user.email'),
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization',
          component: 'e-html-insert',
          valueFormatter: log =>
            log.organization
              ? this._.get(log, 'organization.name') +
                '<br>' +
                `<small>${this._.get(log, 'organization.edrpou')}</small>`
              : null,
          sortable: false,
          filterable: false
        },
        {
          text: 'Action',
          valueFormatter: log => this.$t(log.action),
          sortable: false,
          filterable: false
        },
        {
          text: 'Date',
          valueFormatter: log =>
            log.createdAt ? this.$moment.parseZone(log.createdAt).format('DD.MM.YYYY') : '-',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'document.id': this.documentId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
